import { InputProps } from '@rebass/forms';
import { FormComboGroup, Input } from '../Form';
import React, { ChangeEvent, useCallback } from 'react';
import { FlexProps } from 'rebass';
import { normalizeEmail } from '@ecosconnect/core/src/helpers/string';
import { EmailInput } from './types';

const emailTypes = [
  { value: 'UNKNOWN', label: '-' },
  { value: 'PERSONAL', label: 'Personal' },
  { value: 'WORK', label: 'Work' },
  { value: 'OTHER', label: 'Other' },
];

type EmailInputGroupProps = Omit<FlexProps, 'value' | 'onChange'> & {
  index: number;
  value: EmailInput;
  inputProps?: InputProps;
  onChange?: (
    type: 'phone' | 'email',
    value: EmailInput,
    index: number
  ) => void;
};

const EmailInputGroup: React.FC<EmailInputGroupProps> = (props) => {
  const { value, index, onChange } = props;

  const onTypeChange = useCallback(
    (e: ChangeEvent<any>) => {
      if (onChange) {
        onChange(
          'email',
          {
            ...value,
            subType: e.target.value,
          },
          index
        );
      }
    },
    [value, onChange]
  );

  const onValueChange = useCallback(
    (e: ChangeEvent<any>) => {
      if (onChange) {
        onChange(
          'email',
          {
            ...value,
            value: normalizeEmail(e.target.value),
          },
          index
        );
      }
    },
    [value, onChange]
  );

  return (
    <FormComboGroup
      flexGrow={1}
      {...{ ...(props as any), value: undefined, onChange: undefined }}
    >
      {/*<FormSelect*/}
      {/*  variant="selectCombo"*/}
      {/*  value={value.subType}*/}
      {/*  onChange={onTypeChange}*/}
      {/*  sx={{ width: 100, flexShrink: 0 }}*/}
      {/*>*/}
      {/*  {emailTypes.map(({ value, label }) => (*/}
      {/*    <option key={value} value={value}>*/}
      {/*      {label}*/}
      {/*    </option>*/}
      {/*  ))}*/}
      {/*</FormSelect>*/}
      <Input
        type="text"
        // variant="inputRoundedRight"
        value={value.value}
        onChange={onValueChange}
        data-index={index}
        name="emails"
        placeholder="Email"
        sx={{ flexGrow: 1 }}
        autoComplete="off"
        {...(props.inputProps as any)}
      />
    </FormComboGroup>
  );
};

export default EmailInputGroup;
